// extracted by mini-css-extract-plugin
export default {"button":"CaseAutoApprove_button__8Nz1r"};